export default "__VITE_ASSET__50a583e4__"